import { createSelector } from 'selectors'
import { constant } from './constant'

const getQuestionsContainer = () =>
	createSelector<HTMLElement | null>({ selector: constant.selector.questionContainer })

export const getQuestionScrollerComponents = () => ({
	questionsContainer: getQuestionsContainer(),
})
